<template>
  <section class="map" id="map-places">
    <div class="map-ui">
      <div class="map-ui-left">
        <div class="title-switcher only-mobile" :class="{ open: switcher }">
          <div class="title-dropdown">
            <h2 class="timeline-title active" @click="switcher = !switcher">
              <p>Места</p>
              <img src="@/assets/images/icons/arrow-down.svg" width="20px" />
            </h2>
            <router-link
              tag="h2"
              class="timeline-title"
              :to="{ name: 'events' }"
              >Ивенты</router-link
            >
          </div>
        </div>
        <h2 class="timeline-title map-city">
          {{ getMapCity.ru ? getMapCity.ru : getMapCity.name }}
          <span>{{ count_places }}</span>
        </h2>
        <div class="map-ui-group">
          <div class="input-search">
            <input
              type="search"
              placeholder="Поиск"
              v-model="search"
              @input="searchByTitle"
            />
            <img src="@/assets/images/icons/search.svg" width="22px" />
            <div
              class="dropdown dropdown_search"
              v-if="getPlaces && search.length > 2"
            >
              <div
                class="dropdown-item"
                @click="openPlace(place)"
                v-for="place in getPlaces"
                :key="place.id"
              >
                <div
                  class="dropdown-item__cover"
                  :style="{ backgroundImage: 'url(' + place.cover + ')' }"
                ></div>
                <div class="flex-column">
                  <p class="dropdown-item__title">{{ place.title }}</p>
                  <p class="dropdown-item__place">
                    {{ place.country }} {{ place.state }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- TODO: Сделать поиск себя -->
        <!-- <div class="map-button">
          <img src="@/assets/images/icons/marker.svg" width="22px" >
          <p>Где я?</p>
        </div> -->
      </div>
      <div class="map-ui-right">
        <div class="map-icon" @click="mapstyles = !mapstyles">
          <img src="@/assets/images/icons/edit.svg" width="22px" >
          <!-- <p>Слои</p> -->
          <div class="dropdown dropdown_search" style="width: 200px; height: 300px; right: initial; bottom: initial; left: 0; top: calc(100% + 10px);" v-if="mapstyles" @click.stop>
            <div class="dropdown-item" 
            v-for="(item, index) in customs" 
            :key="index"
            @click="setMapStyle(item)"
          >
              <div class="dropdown-item__cover" 
                :style="{ backgroundImage: 'url(' + item.cover + ')' }"
              ></div>
               <p class="dropdown-item__title">{{ item.title }}</p>
            </div>
          </div>
        </div>
        <!-- <h2 class="timeline-title only-mobile"></h2> -->
        <div class="map-button" @click="loadByCity()">
          <p>Загрузить</p>
        </div>
        <div
          class="map-button map-button_rainbow"
          @click="changeState('sports')"
        >
          <p>Виды спорта</p>
        </div>
      </div>
    </div>
    <div class="map-ui-bottom">
      <div class="map-button only-mobile" @click="backToList()">
        <img src="@/assets/images/icons/list.svg" width="22px" />
        <p>Списком</p>
      </div>
      <div class="map-button map-button_action" @click="createNewPlace()">
        <p>Создать место</p>
      </div>
    </div>
    <LMap
      v-if="showMap"
      :zoom="getZoom"
      :center="getCenter"
      :options="mapOptions"
      @click="mapstyles = false"
      @moveend="moveEnd"
      style="height: 100%"
      ref="myMap"
    >
      <l-tile-layer
        v-for="(layer, index) in getLayers"
        :key="index"
        :url="layer.url"
        :attribution="layer.attribution"
      />
      <v-marker-cluster>
        <!-- Маркер места -->
        <l-marker
          v-for="(place, index) in getPlaces"
          :key="index"
          :lat-lng="getPosition(place)"
          :icon="getPlaceIcon(place)"
          @click="clickHandler(place)"
          :title="place.title"
        >
          <title-popup
            v-if="true"
            v-show="true"
            :title="place.title"
            :zoom="getZoom"
          />
        </l-marker>
      </v-marker-cluster>
    </LMap>
  </section>
</template>

<script>
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { latLng, icon } from "leaflet";
import sports from "./sports";
import places from "@/components/Icons/places";
import VMarkerCluster from "vue2-leaflet-markercluster";
import L from "leaflet";
import TitlePopup from "./components/TitlePopup.vue";
import state_translates from "@/data/translates/states/index.json";

export default {
  name: "MapPlaces",
  data() {
    return {
      center: latLng(59.9308062, 30.3104669),
      mapstyles: false,
      customs: [
        {
          cover: require('@/assets/images/maps/jawg-sunny.jpg'),
          title: 'Jawg Sunny',
          url: "https://{s}.tile.jawg.io/jawg-sunny/{z}/{x}/{y}{r}.png?access-token=WZ50aKhG2m0zE11atv78m2AVKuxophoxxXDV1rbwYU2XmKmbgFRejg8zQArTpKDa",
        },
        {
          cover: require('@/assets/images/maps/jawg-streets.jpg'),
          title: 'Jawg Streets',
          url: 'https://{s}.tile.jawg.io/jawg-streets/{z}/{x}/{y}{r}.png?access-token=WZ50aKhG2m0zE11atv78m2AVKuxophoxxXDV1rbwYU2XmKmbgFRejg8zQArTpKDa',
        },
        {
          cover: require('@/assets/images/maps/jawg-light.jpg'),
          title: 'Jawg Light',
          url: 'https://{s}.tile.jawg.io/jawg-light/{z}/{x}/{y}{r}.png?access-token=WZ50aKhG2m0zE11atv78m2AVKuxophoxxXDV1rbwYU2XmKmbgFRejg8zQArTpKDa',
        },
        {
          cover: require('@/assets/images/maps/jawg-terrain.jpg'),
          title: 'Jawg Terrain',
          url: 'https://{s}.tile.jawg.io/jawg-terrain/{z}/{x}/{y}{r}.png?access-token=WZ50aKhG2m0zE11atv78m2AVKuxophoxxXDV1rbwYU2XmKmbgFRejg8zQArTpKDa',
        },
        {
          cover: require('@/assets/images/maps/jawg-dark.jpg'),
          title: 'Jawg Dark',
          url: 'https://{s}.tile.jawg.io/jawg-dark/{z}/{x}/{y}{r}.png?access-token=WZ50aKhG2m0zE11atv78m2AVKuxophoxxXDV1rbwYU2XmKmbgFRejg8zQArTpKDa',
        },
        {
          cover: require('@/assets/images/maps/jawg-sunny.jpg'),
          title: 'Voyager',
          url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'
        },
        {
          cover: require('@/assets/images/maps/thunderforest-atlas.jpg'),
          title: 'Thunderforest Atas',
          url: 'https://{s}.tile.thunderforest.com/atlas/{z}/{x}/{y}.png?apikey=8007bbc787e14ff9b2152a77a7d07604',
        },
        {
          cover: require('@/assets/images/maps/thunderforest-cycle.jpg'),
          title: 'Thunderforest Cycle',
          url: 'https://{s}.tile.thunderforest.com/cycle/{z}/{x}/{y}.png?apikey=8007bbc787e14ff9b2152a77a7d07604',
        },
        {
          cover: require('@/assets/images/maps/OSM-mapnik.jpg'),
          title: 'OpenStreetMap Mapnik',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
      ],
      layers: [
        {
          url: 'https://{s}.tile.thunderforest.com/atlas/{z}/{x}/{y}.png?apikey=8007bbc787e14ff9b2152a77a7d07604',
          attribution:
            '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        },
        {
          maxZoom: 18,
          url: "https://tile.waymarkedtrails.org/mtb/{z}/{x}/{y}.png",
        },
        {
          maxZoom: 18,
          url: "https://tile.waymarkedtrails.org/slopes/{z}/{x}/{y}.png",
        },
        {
          maxZoom: 18,
          url: "https://tile.waymarkedtrails.org/skating/{z}/{x}/{y}.png",
        },
        {
          url: "https://tiles.opensnowmap.org/pistes/{z}/{x}/{y}.png",
          minZoom: 9,
          maxZoom: 18,
        }],
      // "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png",
      // attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(59.9308062, 30.3104669),
      currentCenter: latLng(59.9308062, 30.3104669),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: false,
      },
      showMap: true,
      count_places: null,
      countries: [],
      country: { name: "Россия", Iso2: "RU" },
      city: { name: "Санкт-Петербург", state_code: "SPE" },
      cities: [],
      c_a: [
        {
          name: "Russian Federation",
          new: "Russia",
        },
      ],
      switcher: false,
    };
  },
  components: {
    VMarkerCluster,
    LMap,
    "l-tile-layer": LTileLayer,
    "l-marker": LMarker,
    "title-popup": TitlePopup,
  },
  computed: {
    search: {
      get() {
        return this.$store.state.filters.search_places;
      },
      set(value) {
        this.$store.commit("setSearchPlaces", value);
      },
    },
    getLayers() {
      let result = [this.layers[0]];
      if (!this.$store.getters.webViewMode) {
        result = this.layers
      }
      return result
    },
    getZoom() {
      return this.$store.getters.getMapZoom;
    },
    getMapCity() {
      return this.$store.getters.getMapCity;
    },
    getCenter() {
      let center = this.$store.getters.getMapCenter;
      return center ? latLng(center) : this.center;
    },
    getDestination() {
      return this.$store.getters.getDestination;
    },
    getPlaces() {
      return this.$store.getters.getPlaces;
    },
    getActivePlace() {
      return this.$store.getters.getActivePlace;
    },
    getFilteredCountries() {
      return this.countries.map((country) => {
        let finded = this.c_a.find((c) => c.name == country.name);
        finded ? country.name == finded.name : "";
        return country;
      });
    },
    getFilters() {
      return this.$store.getters.getFilters;
    },
    getCity() {
      return this.$store.getters.getFilters.find(
        (filter) => filter.group === "city"
      );
    },
    getActiveSports() {
      return this.$store.getters.getActiveSports;
    },
    getUser() {
      return this.$store.getters.getAuthUser;
    },
  },
  methods: {
    setMapStyle(item) {
      localStorage.setItem('mapStyle', JSON.stringify(item))
      this.layers[0].url = item.url
    },
    getMapStyle() {
      let style = localStorage.getItem('mapStyle')
      this.layers[0].url = JSON.parse(style).url
    },
    async loadByCity() {
      let findedCountry = this.getFilters.find((item) => item.group === "city");
      findedCountry
        ? this.getFilters.splice(this.getFilters.indexOf(findedCountry), 1)
        : "";
      this.getFilters.push({ filter: this.getMapCity, group: "city" });
    },
    async moveEnd(data) {
      let center = data.target.getCenter();
      let position = { latitude: center.lat, longitude: center.lng };
      if (this.last_center) {
        let diff_lat = Math.abs(this.last_center.latitude - position.latitude);
        let diff_lng = Math.abs(
          this.last_center.longitude - position.longitude
        );
        if (diff_lat > 0.7 || diff_lng > 0.7) {
          let city = await this.getState(position);
          if (this.getMapCity !== city) {
            this.$store.dispatch("setMapCity", city);
            let count = await this.getCountPlaces();
            this.count_places = `(${count.data})`;
          }
          this.last_center = position;
        }
      } else {
        let city = await this.getState(position);
        if (this.getMapCity !== city) {
          this.$store.dispatch("setMapCity", city);
          let count = await this.getCountPlaces();
          this.count_places = `(${count.data})`;
        }
        this.last_center = position;
      }
    },
    async getState(position) {
      let state = null;
      await this.$axios
        .post("/api/zones/by_coords", { coords: position })
        .then((res) => {
          state = { name: res.data.state, state_code: res.data.state_code };
        });
      state_translates.ru[state.name]
        ? (state.ru = state_translates.ru[state.name])
        : "";
      return state;
    },
    changeState(element) {
      this.$store.dispatch("changeState", { element: element, val: true });
    },
    async getCountPlaces() {
      let filters = this.getFilters;
      if (this.getMapCity) {
        let findedCountry = this.getFilters.find(
          (item) => item.group === "city"
        );
        filters = findedCountry
          ? filters.slice(this.getFilters.indexOf(findedCountry), 1)
          : filters;
        filters.push({ filter: this.getMapCity, group: "city" });
      }

      let params = {
        page: this.getPage,
        filters: filters,
        sports: this.getActiveSports,
        author: this.getUser,
      };

      return await this.$axios.post("/api/places/count", params);
    },
    searchByTitle() {
      if (this.search.length > 2 || this.search.length === 0) {
        let filters = this.getFilters;
        let finded = filters.find((filter) => filter.group === "search");
        let filter = { filter: this.search, group: "search" };
        finded ? filters.splice(filters.indexOf(finded), 1) : "";
        filters.push(filter);
        this.$store.dispatch("setFilters", filters);
      }
    },
    createNewPlace() {
      this.$store.dispatch("setNewType", "places");
      this.$store.dispatch("changeState", { element: "workplace" });
    },
    clickHandler(place) {
      this.$route.params.hash &&
      place.id == this.$route.params.hash.split("&")[0]
        ? ""
        : this.openPlace(place);
      this.$store.dispatch("changeModePlaces", false);
    },
    openPlace(place) {
      this.$store.dispatch("setActivePlace", null);
      this.$router.push({
        name: "place",
        params: { hash: place.id + "&" + place.hash },
      });
    },
    backToList() {
      this.$store.dispatch("changeListPlaces", true);
      this.$router.push("/places");
    },
    getPosition(event) {
      return event.place
        ? latLng(event.place.latitude, event.place.longitude)
        : latLng(event.latitude, event.longitude);
    },
    getPlaceIcon(place) {
      let ic = place.icon ? places[place.icon] : places.flag;
      var template = [ic("#2d2c3a")].join("\n");
      let icon_ready =
        "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(template);
      return icon({
        iconUrl: icon_ready,
        iconSize: [40, 40],
        iconAnchor: [20, 20],
      });
    },
    getIconAvatar() {
      var template = [sports.man].join("\n");
      let icon_ready =
        "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(template);
      return icon({
        iconUrl: icon_ready,
        iconSize: [40, 40],
        iconAnchor: [20, 20],
      });
    },
    getZone(city, country) {
      this.$axios
        .post("/api/zones/by_code", { country: country, region: city })
        .then((res) => {
          this.$store.dispatch(
            "setCenter",
            latLng(res.data.center[1], res.data.center[0])
          );
          this.$store.dispatch("setMapZoom", 7);
        });
    },
    async setCenter(active) {
      if (active && active.place) {
        this.$store.dispatch("setCenter", {
          lat: active.place.latitude,
          lng: active.place.longitude,
        });
      } else if (active && active.latitude && active.longitude) {
        this.$store.dispatch("setCenter", {
          lat: active.latitude,
          lng: active.longitude,
        });
      }
    },
  },
  watch: {
    getActivePlace: "setCenter",
    getDestination(destination) {
      let map = this.$refs.myMap.mapObject;
      L.Routing.control({
        waypoints: [
          L.latLng(destination.destination),
          L.latLng(destination.origin),
        ],
        lineOptions: {
          styles: [{ color: "#53cbb5", opacity: 1, weight: 5 }],
        },
        createMarker: (i, waypoint, n) => {
          let marker = null;
          if (i === n - 1) {
            marker = L.marker(waypoint.latLng, {
              draggable: false,
              bounceOnAdd: false,
              icon: this.getIconAvatar(),
            });
          }
          return marker;
        },
        router: new L.Routing.GraphHopper(
          "701eb64c-4e99-4e23-a53b-ddf04ec94e17",
          {
            urlParameters: {
              vehicle: this.$store.getters.getTravelMode,
            },
          }
        ),
        showAlternatives: true,
      }).addTo(map);
    },
  },
  async mounted() {
    this.getActivePlace ? this.setCenter(this.getActivePlace) : "";
    this.getMapStyle()
  }
};
</script>
